import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { SimpleTooltip } from '@/components/ui/simple-tooltip';

export interface GenerateEntityFooterProps {
  onClearClick: () => void;
  selectedItemsCounter: string;
  /** Number of selected rows — used to toggle the Clear All button + counter */
  selectedItemsCount: number;
  onGenerateClick: () => void;
  isGenerateDisabled: boolean;
  submitButtonLabel: string;
  /**
   * Tooltip shown on hover of the disabled submit button. When provided and the
   * button is disabled, it explains *why* (e.g. "Select at least one row").
   */
  disabledReason?: string;
}

export const GenerateEntityFooter = ({
  onClearClick,
  onGenerateClick,
  selectedItemsCounter: counter,
  selectedItemsCount,
  isGenerateDisabled,
  submitButtonLabel,
  disabledReason,
}: GenerateEntityFooterProps) => {
  const { t } = useTranslation('common');

  const hasSelection = selectedItemsCount > 0;

  const submitButton = (
    <Button onClick={onGenerateClick} disabled={isGenerateDisabled}>
      {submitButtonLabel}
    </Button>
  );

  return (
    <div className="sticky bottom-0 z-[5] border-t border-border bg-surface px-4 py-3">
      <div className="flex items-center justify-between gap-4">
        {hasSelection ? (
          <div className="flex items-center gap-3">
            <Button onClick={onClearClick} size="sm" variant="outline">
              {t('clearAll')}
            </Button>
            <span className="text-sm text-muted-foreground">{counter}</span>
          </div>
        ) : (
          // Keep the left slot present so the submit button stays right-aligned.
          <span aria-hidden />
        )}
        {isGenerateDisabled && disabledReason ? (
          <SimpleTooltip content={disabledReason}>
            <span className="inline-flex">{submitButton}</span>
          </SimpleTooltip>
        ) : (
          submitButton
        )}
      </div>
    </div>
  );
};
